<template>
	<AtomScrollGrid>
		<MoleculeCard
			v-for="(card, index) of cards"
			:key="`organism-card-grid-card-${index}-${card.title}`"
			class="w-full snap-center min-w-[20rem]"
			:title="card.title"
			:description="card.description"
			:icon="card.icon"
		/>
	</AtomScrollGrid>
</template>

<script lang="ts" setup>
import type { CardType } from '#base/core/types/CardType';

type Props = {
	cards: CardType[];
};

defineProps<Props>();
</script>
